/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import {
    FETCH_SUBSCRIBED_API_SCOPES_REQUEST, FETCH_SUBSCRIBED_API_SCOPES_SUCCESS, FETCH_SUBSCRIBED_API_SCOPES_FAILURE
} from '../types/subscribedApiScopes';

export const fetchSubscribedApiScopesRequest = () => {
    return {
        type: FETCH_SUBSCRIBED_API_SCOPES_REQUEST
    }
};

export const fetchSubscribedApiScopesSuccess = (scopes: string[]) => {
    return {
        type: FETCH_SUBSCRIBED_API_SCOPES_SUCCESS,
        payload: scopes
    }
};

export const fetchSubscribedApiScopesFailure = (error: string) => {
    return {
        type: FETCH_SUBSCRIBED_API_SCOPES_FAILURE,
        payload: error
    }
};
